<template>
  <div id="footer" class="gl-footer mt-4">
    <nav
      class="navbar navbar-dark bg-dark fixed-bottom navbar-expand-sm"
      id="footer"
    >
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarCollapse"
        aria-controls="navbarCollapse"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarCollapse">
        <ul class="navbar-nav mr-auto">
          <li class="nav-item">
            <a class="nav-link" href="http://godziklab.org/"
              >&copy;  Dr. Adam Godzik Lab&nbsp;2021</a
            >
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              href="mailto:Godziklab.server@medsch.ucr.edu"
              title="Click to contact us by email: Godziklab.server@medsch.ucr.edu"
            >
              <i class="fa fa-envelope"></i>
            </a>
          </li>
        </ul>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  name: "Footer",
  props: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>